import type { FloatLabelDesignTokens, FloatLabelTokenSections } from '@primeuix/themes/types/floatlabel';

export const root: FloatLabelTokenSections.Root = {
    color: '{formField.floatLabelColor}',
    focusColor: '{formField.floatLabelFocusColor}',
    activeColor: '{formField.floatLabelActiveColor}',
    invalidColor: '{formField.floatLabelInvalidColor}',
    transitionDuration: '0.2s',
    positionX: '{formField.paddingX}',
    positionY: '{formField.paddingY}',
    fontWeight: '700',
    active: {
        fontSize: '0.75rem',
        fontWeight: '700'
    }
};

export const over: FloatLabelTokenSections.Over = {
    active: {
        top: '-1.25rem'
    }
};

export const inside: FloatLabelTokenSections.In = {
    input: {
        paddingTop: '1.5rem',
        paddingBottom: '{formField.paddingY}'
    },
    active: {
        top: '{formField.paddingY}'
    }
};

export const on: FloatLabelTokenSections.On = {
    borderRadius: '{borderRadius.xs}',
    active: {
        background: '{formField.background}',
        padding: '0 0.125rem'
    }
};

export default {
    root,
    over,
    in: inside,
    on
} satisfies FloatLabelDesignTokens;
